import React, { Fragment, useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Menu, Layout } from "antd";
import { HomeOutlined, MenuOutlined, SettingOutlined, ShoppingCartOutlined, LogoutOutlined } from "@ant-design/icons";

import AuthContext from "../../context/auth/authContext";

const { Header } = Layout;
const { SubMenu } = Menu;

const Navbar = () => {
  const navigate = useNavigate();
  const [current, setCurrent] = useState();

  const authContext = useContext(AuthContext);
  const { logout, user, setIsAuthenticated, isAuthenticated } = authContext;

  const parseJwt = (token) => {
    try {
      return JSON.parse(atob(token.split(".")[1]));
    } catch (e) {
      return null;
    }
  };

  const decodedJwt = localStorage.token && parseJwt(localStorage.token);

  const onLogout = () => {
    logout();
    navigate("/login");
  };

  useEffect(() => {
    if (decodedJwt && decodedJwt.exp * 1000 < Date.now()) {
      setIsAuthenticated(false);
    }
  }, []);

  const handleMenuChange = (e) => {
    setCurrent(e.key);
  };

  const authLinks = (
    <Header theme="light" className="myheader">
      <Link to={user?.smartBuilder ? "/smartbuilder/home" : user?.role.includes("Shop") ? "/shop/home" : "/company/home"} className="myheaderitem">
        CHOICE-LINK
      </Link>

      <div style={{
        position: 'absolute',
        left: '50%',
        transform: 'translateX(-50%)',
        textAlign: 'center'
      }}>
        {user && user.name}
      </div>

      {user && (user.role === "Office User" || user.role === "Office Admin") && (
        <Menu
          className="myheaderitem"
          onClick={handleMenuChange}
          selectedKeys={[current]}
          mode="horizontal"
        >
          <SubMenu key="sub22" icon={<MenuOutlined />}>
            <Menu.Item key="settings">
              <Link to="/company/settings">Settings</Link>
            </Menu.Item>
            <Menu.Item key="logout">
              <a onClick={onLogout} href="#!">
                <span className="hide-sm">Logout</span>
              </a>
            </Menu.Item>
          </SubMenu>
        </Menu>
      )}

      {user && !user.smartBuilder && (user.role === "Shop User" || user.role === "Shop Admin") && (
        <Menu
          className="myheaderitem"
          onClick={handleMenuChange}
          selectedKeys={[current]}
          mode="horizontal"
        >
          <SubMenu key="sub22" icon={<MenuOutlined />}>
            <Menu.Item key="settings">
              <Link to="/shop/settings">Settings</Link>
            </Menu.Item>
            {user && user.name === "Matt Schmidt" && (
              <Fragment>
                <Menu.Item key="admin">
                  <Link to="/admin">Admin</Link>
                </Menu.Item>
              </Fragment>
            )}
            <Menu.Item key="logout">
              <a onClick={onLogout} href="#!">
                <span className="hide-sm">Logout</span>
              </a>
            </Menu.Item>
          </SubMenu>
        </Menu>
      )}

      {user && user.smartBuilder && (
        <Menu
          className="myheaderitem-compact"
          onClick={handleMenuChange}
          selectedKeys={[current]}
          mode="horizontal"
          style={{
            marginLeft: 'auto',
            lineHeight: '40px',
            height: '40px'
          }}
        >
          <Menu.Item key="smartbuilder-home" icon={<HomeOutlined />}>
            <Link to="/smartbuild/home">Home</Link>
          </Menu.Item>
          <Menu.Item key="smartbuilder-orders" icon={<ShoppingCartOutlined />}>
            <Link to="/smartbuild/orders">Orders</Link>
          </Menu.Item>
          <Menu.Item key="smartbuilder-settings" icon={<SettingOutlined />}>
            <Link to="/smartbuild/settings">Settings</Link>
          </Menu.Item>
          <Menu.Item key="logout" icon={<LogoutOutlined />} onClick={onLogout}>
            Logout
          </Menu.Item>
        </Menu>
      )}
    </Header>
  );

  const guestLinks = (
    <Header theme="light" className="myheader">
      <div className="myheaderitem">CHOICE-LINK</div>
      <Menu onClick={handleMenuChange} mode="horizontal" theme="light" style={{ marginLeft: 'auto' }}>
        <Menu.Item key="login">
          <Link to="/login">Login</Link>
        </Menu.Item>
      </Menu>
    </Header>
  );

  return <Fragment>{isAuthenticated ? authLinks : guestLinks}</Fragment>;
};

Navbar.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string,
};

Navbar.defaultProps = {
  title: "CHOICE-LINK",
};

export default Navbar;
